webpackJsonp([235131596041995],{

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(45);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page(props) {
	  var page = props.page;
	
	  var html = (page || {}).html;
	
	  return _react2.default.createElement(
	    _Article2.default,
	    null,
	    _react2.default.createElement(_PageHeader2.default, page.frontmatter),
	    _react2.default.createElement(_Content2.default, { html: html })
	  );
	};
	
	Page.propTypes = {
	  page: _propTypes2.default.object.isRequired
	};
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Page = __webpack_require__(526);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Page).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(38);
	
	var _store = __webpack_require__(33);
	
	var _shared = __webpack_require__(58);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Page = __webpack_require__(527);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Footer = __webpack_require__(105);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Seo = __webpack_require__(76);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageTemplate = function (_React$Component) {
	  _inherits(PageTemplate, _React$Component);
	
	  function PageTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PageTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.moveNavigatorAside = _shared.moveNavigatorAside.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PageTemplate.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.navigatorPosition === "is-featured") {
	      this.moveNavigatorAside();
	    }
	  };
	
	  PageTemplate.prototype.render = function render() {
	    var data = this.props.data;
	
	    var facebook = (((data || {}).site || {}).siteMetadata || {}).facebook;
	
	    return _react2.default.createElement(
	      _Main2.default,
	      null,
	      _react2.default.createElement(_Page2.default, { page: data.page }),
	      _react2.default.createElement(_Footer2.default, { footnote: data.footnote }),
	      _react2.default.createElement(_Seo2.default, { data: data.post, facebook: facebook })
	    );
	  };
	
	  return PageTemplate;
	}(_react2.default.Component);
	
	PageTemplate.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  setNavigatorPosition: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    isWideScreen: state.isWideScreen
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PageTemplate);
	
	//eslint-disable-next-line no-undef
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-template-js-e0434750f574a9276ef2.js